import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import Environment from "../../services/environment";
import PubSub from "../../services/PubSub";
import User from "../../services/user";
import TextBox from "../controls/form/TextBox";
import Dropdown from "../controls/form/Dropdown";
import { useGetDomain, useGetUser } from "../../common/Hooks";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import EnvrionmentConfig from "../../config/environment";

const CreateEnvironment = ({ show, onCancel }) => {
    const [translate] = useTranslation();
    const [domain] = useGetDomain();
    const [, setUser] = useGetUser();

    const create = useCallback(async ({ name, description, stage, }) => {
        const response = await Environment.createEnvironment({
            name,
            description,
            stage,
            domain: domain._id
        });
        if (!response.error) {
            const updatedUser = await User.getUser();
            if (!updatedUser.error) {
                setUser({
                    _id: updatedUser.data._id,
                    email: updatedUser.data.email,
                    appAdmin: updatedUser.data.appAdmin,
                    firstName: updatedUser.firstName,
                    lastName: updatedUser.lastName,
                    adminForDomains: updatedUser.data.adminForDomains,
                    uiPermissions: updatedUser.data.uiPermissions
                });
            }
            PubSub.publish("refresh-environment-list", { newEnvironmentId: response.data._id });
            onCancel();
        }
    }, [domain, onCancel, setUser]);

    return (
        <BootstrapModal show={show} backdrop="static">
            <Formik initialValues={{
                name: "",
                description: "",
                stage: "Development",
            }} validationSchema={Yup.object({
                name: Yup.string().min(2, translate("OTM_CHARACTERS_OR_MORE", { minCharacters: 2 })).required(" ")
            })} onSubmit={create}>
                <Form>
                    <BootstrapModal.Header className="h5 text-secondary">{translate("OTM_CREATE_ENVIRONMENT")}</BootstrapModal.Header>
                    <BootstrapModal.Body>
                        <TextBox label={translate("OTM_NAME")} type="text" name="name" />
                        <TextBox label={translate("OTM_DESCRIPTION")} type="text" name="description" css="mt-3" />
                        <div className="mt-3">
                            <Dropdown
                                name="stage"
                                options={EnvrionmentConfig.availableStages}
                                heading={translate("OTM_STAGE")}
                                grow={true}
                            />
                        </div>
                    </BootstrapModal.Body>
                    <BootstrapModal.Footer>
                        <Button type="submit" className="btn-sm">{translate("OTM_CREATE")}</Button>
                        <Button onClick={onCancel} variant="secondary" className="btn-sm">{translate("OTM_CANCEL")}</Button>
                    </BootstrapModal.Footer>
                </Form>
            </Formik>
        </BootstrapModal>
    );
};

export default CreateEnvironment;
